var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 14.6693C4.31767 14.6693 1.33301 11.6846 1.33301 8.0026C1.33301 4.3206 4.31767 1.33594 7.99967 1.33594C11.6817 1.33594 14.6663 4.3206 14.6663 8.0026C14.6663 11.6846 11.6817 14.6693 7.99967 14.6693ZM7.99967 13.3359C9.41416 13.3359 10.7707 12.774 11.7709 11.7738C12.7711 10.7736 13.333 9.41709 13.333 8.0026C13.333 6.58812 12.7711 5.23156 11.7709 4.23137C10.7707 3.23117 9.41416 2.66927 7.99967 2.66927C6.58519 2.66927 5.22863 3.23117 4.22844 4.23137C3.22824 5.23156 2.66634 6.58812 2.66634 8.0026C2.66634 9.41709 3.22824 10.7736 4.22844 11.7738C5.22863 12.774 6.58519 13.3359 7.99967 13.3359V13.3359ZM7.33501 10.6693L4.50634 7.8406L5.44901 6.89794L7.33501 8.78394L11.1057 5.0126L12.049 5.95527L7.33501 10.6693Z",
    fill: "#416EB3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.bd5213ed025094fe23026772b9ad7122.svg";
export { ForwardRef as ReactComponent };